import React, { useState, useEffect, useContext } from "react";
import { Navigate } from 'react-router-dom';
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

import UserService from "services/UserService";
import { getActionPlan, deleteAction } from "services/ConfigServices";
import { ActionContext } from "context/ActionContext";
import { IntInput, FloatInput } from "components/Input/Index.js";
import Button from "components/CustomButtons/Button.js";
import useActionTable from "./useActionTable.js";
import {targetedenergyList} from "variables/lists/action";

const useStyles = makeStyles(styles);

//import "react-table/react-table.css";

// @mui/icons-material

const RTSimpleSavings = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const { gridState } = useActionTable();
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;
  const [editableRowId, setEditableRowId] = useState(false);

  const [newData, setNewData] = useState([]);

  useEffect(() => {
    console.log("useEffect gridState.data");
    setNewData(gridState.data);
  }, [gridState.data]);

  const classes = useStyles();

  const columns = [
    {
      name: "Fluide",
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => targetedenergyList.find((x) => x.id == row.energy)?.name || ""
    },
    {
      name: "Economies (MWh ou m3)",
      selector: (row) => row.savingsvalue,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        editableRowId === row.id ? (
          <IntInput
            //inputTitle={actionVar[params].observations}
            intInput={newData[indexFinder(row.id)].savingsvalue}
            handleIntInputChange={(e) => handleChange(e, row.id)}
            name="savingsvalue"
          />
        ) : (
          row.savingsvalue
        ),
    },
    {
      name: "Economies (%)",
      selector: (row) => row.savingspercent,
      sortable: true,
      cell: (row) =>
        editableRowId === row.id ? (
          <IntInput
            //inputTitle={actionVar[params].observations}
            intInput={newData[indexFinder(row.id)].savingspercent}
            handleIntInputChange={(e) => handleChange(e, row.id)}
            name="savingspercent"
          />
        ) : (
          row.savingspercent
        ),
    },
    // {
    //   name: "Pondération",
    //   selector: (row) => row.savingsponderation,
    //   sortable: true,
    //   cell: (row) =>
    //     editableRowId === row.id ? (
    //       <FloatInput
    //         //inputTitle={actionVar[params].observations}
    //         floatInput={newData[indexFinder(row.id)].savingsponderation}
    //         handleFloatInputChange={(e) => handleChange(e, row.id)}
    //         name="savingsponderation"
    //       />
    //     ) : (
    //       row.savingsponderation
    //     ),
    // },
    actionplanupdate && {
      name: "",
      sortable: false,
      width: "4rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Editer l'impact">
              <Button
                onClick={editEnabled(row)}
                color={editableRowId === row.id ? "info" : "success"}
                className={classes.actionButton}
              >
                {editableRowId === row.id ? (
                  <CheckIcon fontSize="large" />
                ) : (
                  <EditIcon fontSize="large" />
                )}
              </Button>
            </Tooltip>
          </div>
        </>
      ),
    },
  ];

  function indexFinder(rowId) {
    const indexOfId = newData.findIndex((obj) => obj.id == rowId);

    return indexOfId;
  }

  const handleChange = (e, id) => {
    const { name, value } = e.target;
    const indexOfId = newData.findIndex((obj) => obj.id == id);

    let newArray = [...newData];
    newArray[indexOfId][name] = value;

    setNewData(newArray);
  };

  const editEnabled = (row) => async () => {
    console.log(row);
    editableRowId === row.id
      ? setEditableRowId(null)
      : setEditableRowId(row.id);
  };

  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noHeader={true}
        //title="Simulation"
        subHeader
        noDataComponent="Aucune simulation trouvée"
        columns={columns}
        persistTableHead
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        highlightOnHover
        {...gridState}
      />
    </>
  );
};

export default RTSimpleSavings;
